import { useFeatureFlags } from '../config/configSelectors';

import CardFailureConfirmation from './CardFailureConfirmation';
import CardFailureConfirmationNewFlow from './CardFailureConfirmationNewFlow';

export default function CardFailureConfirmationWrapper() {
  const featureFlags = useFeatureFlags();
  const useNewFlow = featureFlags?.useNewErrorCardFlow ?? false;

  if (useNewFlow) return <CardFailureConfirmationNewFlow />;

  return <CardFailureConfirmation />;
}
